import { useEffect, useRef } from "react";


const useClickOutsideSentinel = function <T>(cb: Function, deps?: any[]) {
    const ref = useRef<any | T>(null);

    useEffect(() => {
        const handleOnClick = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target)) cb();
        }
        document.addEventListener('click', handleOnClick, { capture: true });
        return () => document.removeEventListener('click', handleOnClick);
    }, deps ? [ref, ...deps] : [ref])

    return ref;
}

export default useClickOutsideSentinel;